export default __webpack_public_path__ + "static/media/undraw3.f4217504.svg";